module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAoCAMAAACyy+glAAAAQlBMVEVHcEz/Kz7/Kzz/Kz3/Kj7/Kj3/Kj3/KTr/Kjz/Kjz/LDz/Kz3/////5+n/MUL/oan/cX3/Nkf/z9P/8vP/xsr/U2KwO9F8AAAAC3RSTlMAKV3VQXeiE+u9i90WkpMAAADASURBVHheldHZCgMhEETRbDpLtTpL8v+/Gpg8FLEFy3o+NA33NrB1wEbIdFqAEQvVPiHj+wwZv34WopXxA5BxgI5X6DhCwUzBjVh0sgmY2UTMFNyIRSebhAN0vELHEe0JKbCltBF3rJkl4nY2WmKfzdvzQ+xS7GXL3qJp8TY7dmfRznbapSuLdrZil64sfDbqVFm0s+Vc7LdES1ynyMXb2Vnq2mJhNrdyHn8Wgdn6m5iiuzBgI7Npd4MA5yVc/34BFoAm5cJ4X1QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/selected-icon.png
// module id = I8hC
// module chunks = 215